module.exports = __webpack_public_path__ + "static/img/8780_phase_function_Paper_PointsHejduk_Prediction.86422f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8780_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 5WDO
// module chunks = 0